"use client";

import CategoryList from "@/containers/category/CategoryList";
import {
  getCategoryListLayer,
  getFeaturedCategories,
} from "@/requests/category";
import { categoryShowChildIds } from "@/utils/constants";
import { NextPage } from "next";
import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroller";

const CategoryListPage: NextPage = () => {
  const [categories, setCategories] = useState<CategoryItem[]>([]);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);

  const [searchText, setSearchText] = useState<string>("");

  const pageLoading = useRef(true);

  useEffect(() => {
    setLoading(true);
    const abortController = new AbortController();

    const timeout = setTimeout(() => {
      getCategoryListLayer({
        search: searchText,
        currentPage: 1,
        config: {
          signal: abortController.signal,
        },
      })
        .then((data) => {
          setCategories(data || []);
          // console.log(data);
          
          // setTotalPage(data?.totalPage || 1);

          data?.forEach(async (item) => {
            if (categoryShowChildIds.includes(item.id)) {
              const data = await getCategoryListLayer({
                currentPage: 1,
                search: searchText,
                parentId: item.id,
                config: {
                  signal: abortController.signal,
                },
              });
              setCategories((prev) => [...prev, ...(data || [])]);
            }
          });
        })
        .finally(() => {
          setLoading(false);
        });

      // getFeaturedCategories({
      // 	currentPage: 1,
      // 	search: searchText,
      // 	config: {
      // 		signal: abortController.signal,
      // 	},
      // })
      // 	.then((data) => {
      // 		setCategories(data?.data || []);
      // 		setTotalPage(data?.totalPage || 1);
      // 	})
      // 	.finally(() => {
      // 		setLoading(false);
      // 	});
    }, 200);

    return () => {
      clearTimeout(timeout);

      try {
        abortController.signal.throwIfAborted();

        if (abortController.signal.aborted === false) abortController.abort();
      } catch (error) {}
    };
  }, []);

  // useEffect(() => {
  // 	window.scrollTo({
  // 		top: 0,
  // 		behavior: "smooth",
  // 	});
  // }, [page]);

  useEffect(() => {
    pageLoading.current = false;
  }, [categories]);

  const loadNextPage = (page: number) => {
    getFeaturedCategories({
      currentPage: page,
      search: searchText,
      perPage: 20,
    }).then((data) => {
      setCategories((prev) => [...prev, ...(data?.data || [])]);
      setTotalPage(data?.totalPage || 1);
      setPage(page);
    });
  };

  const maxPages = Math.ceil(totalPage);

  const loadMoreHandler = () => {
    if (!pageLoading.current) {
      pageLoading.current = true;
      loadNextPage(page + 1);
    }
  };

  const filteredCategories = categories.filter((category) => {
    return (
      category.name.toLowerCase().includes(searchText.toLowerCase()) ||
      category.slug.toLowerCase().includes(searchText.toLowerCase()) ||
      category.id?.toString()?.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const Comp: any = InfiniteScroll;

  return (
    <div className="pb-6">
      <div className={`container`}>
        {/* search form */}
        <div className="flex pt-8">
          <div className="w-full md:w-1/2 lg:w-1/3 max-w-[500px]">
            <input
              type="text"
              className="w-full border border-gray-300 rounded-md p-2 focus:outline-none"
              placeholder="Search category..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>

        <Comp
          pageStart={0}
          loadMore={loadMoreHandler}
          threshold={500}
          initialLoad={false}
          hasMore={page < maxPages}
          loader={
            <div className="'w-full py-10 flex" key={"loader"}>
              <div className="mx-auto w-10 h-10 rounded-full border border-gray2 border-b-transparent animate-spin"></div>
            </div>
          }
        >
          <CategoryList categories={filteredCategories} loading={loading} />
        </Comp>
      </div>
    </div>
  );
};

export default CategoryListPage;
